import { render } from "./icon.vue?vue&type=template&id=3c0443cc&lang=pug"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"
script.render = render

export default script